var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.doShowDialog)?_c('v-dialog',{attrs:{"value":true,"persistent":"","width":"100%","max-width":"960px"}},[_c('MessageCard',{attrs:{"message":_vm.message,"has-badge":_vm.hasBadge},on:{"close":_vm.closeMessage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }